/** Saves a Blob (e.g. a generated CSV or a file from an API) as fileName in the browser. */
export const downloadBlob = (blob, fileName) => {
	const url = URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.download = fileName;
	link.click();
	URL.revokeObjectURL(url);
};
